import i18n from 'i18n'
import * as React from "react"
import { SelectAjaxSeeker } from "ui-seeker/core"

import { FORM_URL } from 'app/@common/constants'


export default function SelectCityTo({ ...props }) {

    const myProps = {
        urlAjax: FORM_URL.PACKAGES_CITY,
        placeholder: i18n.t('common:filters.selectCityTo'),
        icon: { icon: 'city' },
        isMulti: false,
        ...props
    }

    return <SelectAjaxSeeker {...myProps} />
}